import { connect } from "react-redux";

// core
import * as LoginSession from "@mochi/misc/auth/util/loginSession";
import { loadTokenLogout } from "@mochi/misc/auth/logout/redux";
import { Logout } from "./Logout";

import { IPanadenState } from "../../@models";

export const StyledConnectLogout = connect(
  (state: IPanadenState) => ({
    logOutStatus:
      LoginSession.isExpired() &&
      state.logoutApiToken &&
      !(state.logoutApiToken as any).loginTokenSuccess &&
      !(state as any).logoutApiToken.apiTokenSuccess
  }),
  dispatch => ({ logout: () => dispatch(loadTokenLogout()) })
)(Logout);

export default StyledConnectLogout;
